// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.0
//   protoc               v3.20.3
// source: custom_agent.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Header } from "./metadata";
import { ScheduledJobRunProto } from "./schedule";
import { SlackNotification } from "./slack";

export const protobufPackage = "com.meritic.newton";

/** Represents a scenario for custom agents. */
export interface ScenarioProto {
  /** Unique identifier for the scenario. */
  id?:
    | number
    | undefined;
  /** Description of the issue or scenario. */
  issue?:
    | string
    | undefined;
  /** Trigger conditions that activate this scenario. */
  trigger?:
    | string
    | undefined;
  /** Investigation steps to diagnose the root cause. */
  investigation?:
    | string
    | undefined;
  /** Reporting instructions for the scenario. */
  reporting?:
    | string
    | undefined;
  /** Flag to represent if scenario is enabled or not. */
  disable?: boolean | undefined;
}

/**
 * IMPORTANT: Field names in these protos must remain backward compatible,
 * as they are persisted as JSON in Newton.
 * Represents a agent.
 */
export interface CustomAgentProto {
  /** Header containing metadata about the agent. */
  header?:
    | Header
    | undefined;
  /** List of plan headers. */
  plan_headers: Header[];
  /** Last runs of select plan. */
  plan_runs: CustomAgentProto_LastRunsProto[];
  /** Job last runs. */
  job_last_runs?:
    | number
    | undefined;
  /**
   * Slack channel id.
   * @Deprecated
   */
  slack_channel?:
    | string
    | undefined;
  /** Job specific questions. */
  job_questions: string[];
  /** Job objective. */
  objective?:
    | string
    | undefined;
  /** Example insights. */
  example?:
    | string
    | undefined;
  /** Additional specific context for the agent. */
  custom_instructions?:
    | string
    | undefined;
  /**
   * If the manager wants the agent to highlight key issues in the output,
   * then this field should be set.
   */
  key_issues?:
    | string
    | undefined;
  /** Settings required to send slack notification. */
  slack_notification?:
    | SlackNotification
    | undefined;
  /** Output of agent's runs. */
  agent_runs: ScheduledJobRunProto[];
  /** LLM model configuration. */
  model_config?:
    | CustomAgentProto_ModelConfig
    | undefined;
  /** List of scenarios for the agent. */
  scenarios: ScenarioProto[];
}

export interface CustomAgentProto_LastRunsProto {
  plan_id?: string | undefined;
  last_runs?: number | undefined;
}

export interface CustomAgentProto_ModelConfig {
  model_name?: string | undefined;
  model_type?: string | undefined;
  temperature?: number | undefined;
}

function createBaseScenarioProto(): ScenarioProto {
  return {
    id: undefined,
    issue: undefined,
    trigger: undefined,
    investigation: undefined,
    reporting: undefined,
    disable: undefined,
  };
}

export const ScenarioProto: MessageFns<ScenarioProto> = {
  encode(message: ScenarioProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      writer.uint32(8).int32(message.id);
    }
    if (message.issue !== undefined) {
      writer.uint32(18).string(message.issue);
    }
    if (message.trigger !== undefined) {
      writer.uint32(26).string(message.trigger);
    }
    if (message.investigation !== undefined) {
      writer.uint32(34).string(message.investigation);
    }
    if (message.reporting !== undefined) {
      writer.uint32(42).string(message.reporting);
    }
    if (message.disable !== undefined) {
      writer.uint32(48).bool(message.disable);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScenarioProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScenarioProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.issue = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.trigger = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.investigation = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.reporting = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.disable = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScenarioProto {
    return {
      id: isSet(object.id) ? globalThis.Number(object.id) : undefined,
      issue: isSet(object.issue) ? globalThis.String(object.issue) : undefined,
      trigger: isSet(object.trigger) ? globalThis.String(object.trigger) : undefined,
      investigation: isSet(object.investigation) ? globalThis.String(object.investigation) : undefined,
      reporting: isSet(object.reporting) ? globalThis.String(object.reporting) : undefined,
      disable: isSet(object.disable) ? globalThis.Boolean(object.disable) : undefined,
    };
  },

  toJSON(message: ScenarioProto): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = Math.round(message.id);
    }
    if (message.issue !== undefined) {
      obj.issue = message.issue;
    }
    if (message.trigger !== undefined) {
      obj.trigger = message.trigger;
    }
    if (message.investigation !== undefined) {
      obj.investigation = message.investigation;
    }
    if (message.reporting !== undefined) {
      obj.reporting = message.reporting;
    }
    if (message.disable !== undefined) {
      obj.disable = message.disable;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScenarioProto>, I>>(base?: I): ScenarioProto {
    return ScenarioProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScenarioProto>, I>>(object: I): ScenarioProto {
    const message = createBaseScenarioProto();
    message.id = object.id ?? undefined;
    message.issue = object.issue ?? undefined;
    message.trigger = object.trigger ?? undefined;
    message.investigation = object.investigation ?? undefined;
    message.reporting = object.reporting ?? undefined;
    message.disable = object.disable ?? undefined;
    return message;
  },
};

function createBaseCustomAgentProto(): CustomAgentProto {
  return {
    header: undefined,
    plan_headers: [],
    plan_runs: [],
    job_last_runs: undefined,
    slack_channel: undefined,
    job_questions: [],
    objective: undefined,
    example: undefined,
    custom_instructions: undefined,
    key_issues: undefined,
    slack_notification: undefined,
    agent_runs: [],
    model_config: undefined,
    scenarios: [],
  };
}

export const CustomAgentProto: MessageFns<CustomAgentProto> = {
  encode(message: CustomAgentProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    for (const v of message.plan_headers) {
      Header.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.plan_runs) {
      CustomAgentProto_LastRunsProto.encode(v!, writer.uint32(26).fork()).join();
    }
    if (message.job_last_runs !== undefined) {
      writer.uint32(32).int32(message.job_last_runs);
    }
    if (message.slack_channel !== undefined) {
      writer.uint32(42).string(message.slack_channel);
    }
    for (const v of message.job_questions) {
      writer.uint32(50).string(v!);
    }
    if (message.objective !== undefined) {
      writer.uint32(58).string(message.objective);
    }
    if (message.example !== undefined) {
      writer.uint32(66).string(message.example);
    }
    if (message.custom_instructions !== undefined) {
      writer.uint32(74).string(message.custom_instructions);
    }
    if (message.key_issues !== undefined) {
      writer.uint32(82).string(message.key_issues);
    }
    if (message.slack_notification !== undefined) {
      SlackNotification.encode(message.slack_notification, writer.uint32(90).fork()).join();
    }
    for (const v of message.agent_runs) {
      ScheduledJobRunProto.encode(v!, writer.uint32(98).fork()).join();
    }
    if (message.model_config !== undefined) {
      CustomAgentProto_ModelConfig.encode(message.model_config, writer.uint32(106).fork()).join();
    }
    for (const v of message.scenarios) {
      ScenarioProto.encode(v!, writer.uint32(114).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CustomAgentProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCustomAgentProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.plan_headers.push(Header.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.plan_runs.push(CustomAgentProto_LastRunsProto.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.job_last_runs = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.slack_channel = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.job_questions.push(reader.string());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.objective = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.example = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.custom_instructions = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.key_issues = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.slack_notification = SlackNotification.decode(reader, reader.uint32());
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.agent_runs.push(ScheduledJobRunProto.decode(reader, reader.uint32()));
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.model_config = CustomAgentProto_ModelConfig.decode(reader, reader.uint32());
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.scenarios.push(ScenarioProto.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CustomAgentProto {
    return {
      header: isSet(object.header) ? Header.fromJSON(object.header) : undefined,
      plan_headers: globalThis.Array.isArray(object?.plan_headers)
        ? object.plan_headers.map((e: any) => Header.fromJSON(e))
        : [],
      plan_runs: globalThis.Array.isArray(object?.plan_runs)
        ? object.plan_runs.map((e: any) => CustomAgentProto_LastRunsProto.fromJSON(e))
        : [],
      job_last_runs: isSet(object.job_last_runs) ? globalThis.Number(object.job_last_runs) : undefined,
      slack_channel: isSet(object.slack_channel) ? globalThis.String(object.slack_channel) : undefined,
      job_questions: globalThis.Array.isArray(object?.job_questions)
        ? object.job_questions.map((e: any) => globalThis.String(e))
        : [],
      objective: isSet(object.objective) ? globalThis.String(object.objective) : undefined,
      example: isSet(object.example) ? globalThis.String(object.example) : undefined,
      custom_instructions: isSet(object.custom_instructions)
        ? globalThis.String(object.custom_instructions)
        : undefined,
      key_issues: isSet(object.key_issues) ? globalThis.String(object.key_issues) : undefined,
      slack_notification: isSet(object.slack_notification)
        ? SlackNotification.fromJSON(object.slack_notification)
        : undefined,
      agent_runs: globalThis.Array.isArray(object?.agent_runs)
        ? object.agent_runs.map((e: any) => ScheduledJobRunProto.fromJSON(e))
        : [],
      model_config: isSet(object.model_config) ? CustomAgentProto_ModelConfig.fromJSON(object.model_config) : undefined,
      scenarios: globalThis.Array.isArray(object?.scenarios)
        ? object.scenarios.map((e: any) => ScenarioProto.fromJSON(e))
        : [],
    };
  },

  toJSON(message: CustomAgentProto): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = Header.toJSON(message.header);
    }
    if (message.plan_headers?.length) {
      obj.plan_headers = message.plan_headers.map((e) => Header.toJSON(e));
    }
    if (message.plan_runs?.length) {
      obj.plan_runs = message.plan_runs.map((e) => CustomAgentProto_LastRunsProto.toJSON(e));
    }
    if (message.job_last_runs !== undefined) {
      obj.job_last_runs = Math.round(message.job_last_runs);
    }
    if (message.slack_channel !== undefined) {
      obj.slack_channel = message.slack_channel;
    }
    if (message.job_questions?.length) {
      obj.job_questions = message.job_questions;
    }
    if (message.objective !== undefined) {
      obj.objective = message.objective;
    }
    if (message.example !== undefined) {
      obj.example = message.example;
    }
    if (message.custom_instructions !== undefined) {
      obj.custom_instructions = message.custom_instructions;
    }
    if (message.key_issues !== undefined) {
      obj.key_issues = message.key_issues;
    }
    if (message.slack_notification !== undefined) {
      obj.slack_notification = SlackNotification.toJSON(message.slack_notification);
    }
    if (message.agent_runs?.length) {
      obj.agent_runs = message.agent_runs.map((e) => ScheduledJobRunProto.toJSON(e));
    }
    if (message.model_config !== undefined) {
      obj.model_config = CustomAgentProto_ModelConfig.toJSON(message.model_config);
    }
    if (message.scenarios?.length) {
      obj.scenarios = message.scenarios.map((e) => ScenarioProto.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CustomAgentProto>, I>>(base?: I): CustomAgentProto {
    return CustomAgentProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CustomAgentProto>, I>>(object: I): CustomAgentProto {
    const message = createBaseCustomAgentProto();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.plan_headers = object.plan_headers?.map((e) => Header.fromPartial(e)) || [];
    message.plan_runs = object.plan_runs?.map((e) => CustomAgentProto_LastRunsProto.fromPartial(e)) || [];
    message.job_last_runs = object.job_last_runs ?? undefined;
    message.slack_channel = object.slack_channel ?? undefined;
    message.job_questions = object.job_questions?.map((e) => e) || [];
    message.objective = object.objective ?? undefined;
    message.example = object.example ?? undefined;
    message.custom_instructions = object.custom_instructions ?? undefined;
    message.key_issues = object.key_issues ?? undefined;
    message.slack_notification = (object.slack_notification !== undefined && object.slack_notification !== null)
      ? SlackNotification.fromPartial(object.slack_notification)
      : undefined;
    message.agent_runs = object.agent_runs?.map((e) => ScheduledJobRunProto.fromPartial(e)) || [];
    message.model_config = (object.model_config !== undefined && object.model_config !== null)
      ? CustomAgentProto_ModelConfig.fromPartial(object.model_config)
      : undefined;
    message.scenarios = object.scenarios?.map((e) => ScenarioProto.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCustomAgentProto_LastRunsProto(): CustomAgentProto_LastRunsProto {
  return { plan_id: undefined, last_runs: undefined };
}

export const CustomAgentProto_LastRunsProto: MessageFns<CustomAgentProto_LastRunsProto> = {
  encode(message: CustomAgentProto_LastRunsProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.plan_id !== undefined) {
      writer.uint32(10).string(message.plan_id);
    }
    if (message.last_runs !== undefined) {
      writer.uint32(16).int32(message.last_runs);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CustomAgentProto_LastRunsProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCustomAgentProto_LastRunsProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.plan_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.last_runs = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CustomAgentProto_LastRunsProto {
    return {
      plan_id: isSet(object.plan_id) ? globalThis.String(object.plan_id) : undefined,
      last_runs: isSet(object.last_runs) ? globalThis.Number(object.last_runs) : undefined,
    };
  },

  toJSON(message: CustomAgentProto_LastRunsProto): unknown {
    const obj: any = {};
    if (message.plan_id !== undefined) {
      obj.plan_id = message.plan_id;
    }
    if (message.last_runs !== undefined) {
      obj.last_runs = Math.round(message.last_runs);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CustomAgentProto_LastRunsProto>, I>>(base?: I): CustomAgentProto_LastRunsProto {
    return CustomAgentProto_LastRunsProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CustomAgentProto_LastRunsProto>, I>>(
    object: I,
  ): CustomAgentProto_LastRunsProto {
    const message = createBaseCustomAgentProto_LastRunsProto();
    message.plan_id = object.plan_id ?? undefined;
    message.last_runs = object.last_runs ?? undefined;
    return message;
  },
};

function createBaseCustomAgentProto_ModelConfig(): CustomAgentProto_ModelConfig {
  return { model_name: undefined, model_type: undefined, temperature: undefined };
}

export const CustomAgentProto_ModelConfig: MessageFns<CustomAgentProto_ModelConfig> = {
  encode(message: CustomAgentProto_ModelConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.model_name !== undefined) {
      writer.uint32(10).string(message.model_name);
    }
    if (message.model_type !== undefined) {
      writer.uint32(18).string(message.model_type);
    }
    if (message.temperature !== undefined) {
      writer.uint32(29).float(message.temperature);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CustomAgentProto_ModelConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCustomAgentProto_ModelConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.model_name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.model_type = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.temperature = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CustomAgentProto_ModelConfig {
    return {
      model_name: isSet(object.model_name) ? globalThis.String(object.model_name) : undefined,
      model_type: isSet(object.model_type) ? globalThis.String(object.model_type) : undefined,
      temperature: isSet(object.temperature) ? globalThis.Number(object.temperature) : undefined,
    };
  },

  toJSON(message: CustomAgentProto_ModelConfig): unknown {
    const obj: any = {};
    if (message.model_name !== undefined) {
      obj.model_name = message.model_name;
    }
    if (message.model_type !== undefined) {
      obj.model_type = message.model_type;
    }
    if (message.temperature !== undefined) {
      obj.temperature = message.temperature;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CustomAgentProto_ModelConfig>, I>>(base?: I): CustomAgentProto_ModelConfig {
    return CustomAgentProto_ModelConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CustomAgentProto_ModelConfig>, I>>(object: I): CustomAgentProto_ModelConfig {
    const message = createBaseCustomAgentProto_ModelConfig();
    message.model_name = object.model_name ?? undefined;
    message.model_type = object.model_type ?? undefined;
    message.temperature = object.temperature ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
